export const capitalize = (str) =>
  `${str.charAt(0).toUpperCase()}${str.slice(1)}`

export const titleCase = (str) =>
  str.split(' ').map(capitalize).join(' ')
